import React from 'react';
import ProgressBar from './ProgressBar';
import './ProgressBarWithInlineMarkers.styl';

/**
   Wrapper component for ProgressBar that adds styles so the progress markers
   will appear 'inline' with the bar (i.e. overlayed on top of it)
 */
export default class ProgressBarWithInlineMarkers extends React.PureComponent {
  render() {
    return (
      <ProgressBar
        {...this.props}
        className="progress-bar-with-inline-markers"
        markers={
          // on the edges the marker looks bad due to the rounded corners
          // so just don't show it.
          // TODO maybe find a better solution
          this.props.markers.filter(({percentage}) => percentage > 3 && percentage < 97)
        }
      />
    );
  }
}
